import { createSlice } from '@reduxjs/toolkit';
import { statusTypes } from '@/constants/types';
import { fetchBrands, fetchCategories } from '../thunk/categories-thunk';

const initialState = {
  items: [],
  current: {},
  currentChildren: [],
  selectedItem: null,
  selectedBrand: null,
  total: 0,
  isLoading: false,
  error: null,

  brands: {
    top: [],
    others: [],
  },
  totalBrands: 0,
  fetchBrandStatus: statusTypes.idle,
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    resetCategoriesForCache() {
      return initialState;
    },
    updateCurrentCategoryWithChildren: (state, action) => {
      const { currentCategory, selectedCategory, children, selectedBrand } =
        action.payload;
      state.current = {
        ...currentCategory,
        selectedCategory,
        selectedBrand: selectedBrand ?? null,
        children,
      };
      state.currentChildren = children || [];
      state.selectedItem = selectedCategory || null;
    },
    reset: (state) => {
      state.categories = [];
      state.current = {};
      state.total = 0;
      state.isLoading = false;
      state.error = null;

      state.brands = [];
      state.totalBrands = 0;
      state.fetchBrandStatus = statusTypes.idle;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.items = action.payload;
        state.total = action.payload.length;
        state.isLoading = false;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchBrands.pending, (state) => {
        state.fetchBrandStatus = statusTypes.loading;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.brands.top = action?.payload?.top_brands ?? [];
        state.brands.others = action?.payload?.other_brands ?? [];
        state.totalBrands = action?.payload?.length;
        state.fetchBrandStatus = statusTypes.succeeded;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.fetchBrandStatus = statusTypes.failed;
        state.error = action.payload;
      });
  },
});

export const {
  updateCurrentCategoryWithChildren,
  reset,
  resetCategoriesForCache,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
